"use strict";

exports.__esModule = true;
exports.TokenBalance = void 0;
var _fixedPointNumber = require("./fixed-point-number");
class TokenBalance {
  constructor(token, balance) {
    this._token = void 0;
    this._balance = void 0;
    this._token = token;
    this._balance = balance || _fixedPointNumber.FixedPointNumber.ZERO;
  }
  get token() {
    return this._token;
  }
  get balance() {
    return this._balance;
  }
  clone() {
    return new TokenBalance(this._token.clone(), this._balance.clone());
  }
}
exports.TokenBalance = TokenBalance;